import { useFeature } from "../features";

export const useAddExternalAccountPermission = () => {
  const { featureEquals } = useFeature();

  return featureEquals("indigo.ExternalAccount_permission", "*");
};
